// extracted by mini-css-extract-plugin
export default {"overlayArea":"overlayArea-3nRYr","scroll":"scroll-3Up1g","accountPanelV2":"accountPanelV2-lDjxn","links":"links-2ziJY"};